import {createGlobalStyle} from "styled-components";
export const SCROLLBAR_WIDTH = '7px';

export const GlobalStyles = createGlobalStyle`

    // Chrome and Safari scrollbar
    *::-webkit-scrollbar {
        width: ${SCROLLBAR_WIDTH};
    }

    *::-webkit-scrollbar-track {
        background-color: rgba(${props => props.theme.colors.mediumRgb}, 0.1);
    }

    *::-webkit-scrollbar-thumb {
        background-color: rgba(${props => props.theme.colors.mediumRgb}, 0.5);
    }

    *::-webkit-scrollbar-thumb:hover {
        background-color: rgba(${props => props.theme.colors.mediumRgb}, 0.8);
    }

    html {
        
        font-size: 16px;
        font-family: var(--ion-font-family);
        font-weight: ${props => props.theme.fontWeight.regular};
        scrollbar-gutter: stable;

        ${props => props.theme.screenMediaQuery.sAndBelow} {
            font-size: 14px;
        }
        
        ${props => props.theme.screenMediaQuery.xsAndBelow} {
            font-size: 13px;
        }
        
    }
    
    body {
        font-size: ${props => props.theme.fontSize.body1};
        color: ${props => props.theme.colors.dark};
        background-color: ${props => props.theme.colors.light};
    }
    
    h1 {
        font-size: ${props => props.theme.fontSize.h1};
    }

    h2 {
        font-size: ${props => props.theme.fontSize.h2};
    }

    h3 {
        font-size: ${props => props.theme.fontSize.h3};
    }
    h4 {
        font-size: ${props => props.theme.fontSize.h4};
    }
    h5 {
        font-size: ${props => props.theme.fontSize.h4};
    }
    h6 {
        font-size: ${props => props.theme.fontSize.h6};
    }

    ion-header {
        &:after {
            display: none;
        }
    }
 
    ion-footer {
        &:before {
            display: none;
        }
    }

    ion-icon {
        pointer-events: none;
    }
 

    .shopping-cart-notifications-popover .popover-content {
        border: solid 1px rgba(${props => props.theme.colors.mediumRgb}, 0.75);
        background-color: ${props => props.theme.colors.light};
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
    }
    
    /* Firefox */
    input[type=number] {
            -moz-appearance: textfield;
    }

    .sfcModal-dialog {
            height: 100%; !important;
            width: 100%; !important;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
    }

    .sfcModal-content {
            height: 90%; !important;
            width: 65%; !important;
            border-radius: ${props => props.theme.border.defaultRadius};
            box-shadow: ${props => props.theme.boxShadow.shadow6};
    }

    .sfcModal-content iframe {
            min-height: 100%; !important;
    }

    ${props => props.theme.screenMediaQuery.lAndBelow} {

            .sfcModal-content {
                    width: 85%; !important;
            }
    }
    
    ${props => props.theme.screenMediaQuery.sAndBelow} {
           
            .sfcModal-content {
                    height: 100%; !important;
                    width: 100%; !important;
                    border-radius: unset;
                    box-shadow: unset;
            }
    }
    
   

`
